import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button, Label, Card, CardBody, UncontrolledTooltip } from 'reactstrap';
import { Form, Field, FormGroup, Radio, RadioGroup } from '@availity/form';
import { SelectField } from '@availity/select';
import { DateField } from '@availity/date';
import '@availity/yup';
import * as yup from 'yup';
import moment from 'moment';
import "@availity/reactstrap-validation-date/styles.scss";
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProgressBar from '../../Common/components/ProgressBar';
import qualitystore from '../stores/QualityStore';

@observer
export default class MemberInfo extends Component {
  constructor(props) {
    super(props);
    if (qualitystore.getPageStatus('#memberinfo') !== 'stepwizard-step active') {
      qualitystore.setPageStatus('#memberinfo', 'active');
    }
  }

  setMemberFirst = event => {
    const { value } = event.target;
    qualitystore.updateMemberFirst(value);
  }

  setMemberLast = event => {
    const { value } = event.target;
    qualitystore.updateMemberLast(value);
  }

  setMemberInitial = event => {
    const { value } = event.target;
    qualitystore.updateMemberInitial(value);
  }

  setMemberDOB = value => {
    qualitystore.dateValueSetter(value);
  }

  setMemberSubscriberId = event => {
    const { value } = event.target;
    qualitystore.updateMemberSubscriberId(value);
  }

  setMemberStreetSuite = event => {
    const { value } = event.target;
    qualitystore.updateMemberStreetSuite(value);
  }

  setMemberCity = event => {
    const { value } = event.target;
    qualitystore.updateMemberCity(value);
  }

  setMemState = value => {
    qualitystore.updateMemState(value);
  }

  setMemZip = event => {
    const { value } = event.target;
    qualitystore.updateMemZip(value);
  }

  setMemPhone = event => {
    const { value } = event.target;
    qualitystore.updateMemPhone(value);
  }

  setMemPhoneType = event => {
    qualitystore.updatePhoneType(event.target.value);
  }

  setPGFirstName = event => {
    qualitystore.updatePGFirstName(event.target.value);
  }

  setPGLastName = event => {
    qualitystore.updatePGLastName(event.target.value);
  }

  setPGMiddleInital = event => {
    qualitystore.updatePGMiddleInitial(event.target.value);
  }

  setPGRelation = event => {
    qualitystore.updatePGRelation(event.target.value);
  }

  setAuthRepFirstName = event => {
    qualitystore.updateAuthRepFirstName(event.target.value);
  }

  setAuthRepLastName = event => {
    qualitystore.updateAuthRepLastName(event.target.value);
  }

  setAuthRepMiddleInital = event => {
    qualitystore.updateAuthRepMiddleInitial(event.target.value);
  }

  setAuthRepRelation = event => {
    qualitystore.updateAuthRepRelation(event.target.value);
  }

  submit = () => {
    const { history } = this.props;
    history.push('/practitionerlocation');
  }

  render() {
    const { member, pg, authRep, states } = qualitystore;
    const memPhoneType = member.memPhoneType;

    return (
      <Card>
        <CardBody className="p-40">
          <ProgressBar />
          <NavLink exact to="/preparerinfo" className={'btn btn-link backBtn'}>
            <i className="icon icon-angle-left" />
            Back
          </NavLink>
          <div className="border-form">
            <Form
              onSubmit={this.submit}
              initialValues={{
                memberFirst: member.memberFirst,
                memberLast: member.memberLast,
                memberInitial: member.memberInitial,
                DOB: member.memDOB,
                subscriberId: member.subscriberId,
                memberStreetSuite: member.memStreetSuite,
                memCity: member.memCity,
                memState: member.memState,
                memZip: member.memZip,
                memPhone: member.memPhone,
                memberPhoneRadio: memPhoneType,
                pgFirstName: pg.pgFirstName,
                pgLastName: pg.pgLastName,
                pgMiddleInitial: pg.pgMiddleInitial,
                pgRelation: pg.pgRelation,
                authRepFirstName: authRep.authRepFirstName,
                authRepLastName: authRep.authRepLastName,
                authRepMiddleInitial: authRep.authRepMiddleInitial,
                authRepRelation: authRep.authRelation
              }}
              validationSchema={yup.object().shape({
                memberFirst: yup
                  .string()
                  .required('Member\'s First Name is required!')
                  .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Member\'s First Name should start and end with a letter.'),
                memberLast: yup
                  .string()
                  .required('Member\'s First Name is required!')
                  .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Member\'s Last Name should start and end with a letter.'),
                memberInitial: yup
                  .string()
                  .matches(/[A-Za-z]$/, 'No numbers or special characters allowed!'),
                DOB: yup
                  .date()
                  .max(moment().format('MM/DD/YYYY'), 'Date cannot be in future')
                  .required('Date of Birth is required')
                  .typeError('Invalid Date'),
                subscriberId: yup
                  .string()
                  .min(12, 'Subscriber Id has to be a 12 alpha-numeric number.')
                  .matches(/^([A-Za-z]{3})\d{9}$/, 'Subscriber Id has to begin with a 3 character letter prefix, followed by 9 digit numeric characters')
                  .required('Subscriber Id is required!'),
                memberStreetSuite: yup
                  .string()
                  .required('Member Street Address/Suite Number is required!'),
                memCity: yup
                  .string()
                  .matches(/^[A-Za-z][ '(),.A-Za-z]+$/, 'Invalid City Name')
                  .required('City is required!'),
                memState: yup
                  .string()
                  .required('Please select a state'),
                memZip: yup
                  .string()
                  .min(5, 'Zip code must be at least 5 characters')
                  .matches(/^\d{5}(-\d{4})?$/, 'Zip code incomplete or incorrect, please enter zip code!')
                  .required('Zip Code is required!'),
                memPhone: yup
                  .string()
                  .min(10, 'Phone number must be 10 digits.')
                  .matches(/^\d+$/, 'Phone number is incorrect or incomplete, please enter correct phone number')
                  .required('Phone number is required!'),
                pgFirstName:
                  yup
                    .string()
                    .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Parent/Guardian First Name should start and end with a letter.')
                    .isRequired(member.isMemberMinor === 'Yes', 'Parent/Guardian First Name is required'),
                pgLastName:
                  yup
                    .string()
                    .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Parent/Guardian Last Name should start and end with a letter.')
                    .isRequired(member.isMemberMinor === 'Yes', 'Parent/Guardian Last Name is required'),
                pgMiddleInitial: yup
                  .string()
                  .matches(/^[A-Za-z]$/, 'No numbers or special characters allowed!'),
                pgRelation:
                  yup
                    .string()
                    .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Relationship should start and end with a letter.')
                    .isRequired(member.isMemberMinor === 'Yes', 'Relationship is required'),
                authRepFirstName: yup
                  .string()
                  .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Authorized Representative First Name should start and end with a letter.'),
                authRepLastName: yup
                  .string()
                  .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Authorized Representative Last Name should start and end with a letter.'),
                authRepMiddleInitial: yup
                  .string()
                  .matches(/^[A-Za-z]$/, 'No numbers or special characters allowed!'),
                authRepRelation: yup
                  .string()
                  .matches(/^[A-Za-z]+[ ',.A-Za-z\-]*[ A-Za-z]$/, 'Relationship should start and end with a letter.')
              })}
            >
              <h2 className="primarycardTitle">
                <b>Member Information</b>
              </h2>
              <div className="titleSpacer" />
              <p>{`Asterisks (*) mark required fields`}</p>
              <div className='spacer' />
              <Row>
                <Col xs="12" sm="5" md="5">
                  <FormGroup for="memberFirst">
                    <Label for="memberFirst">
                      Member's First Name*
                    </Label>
                    <Field
                      type="text"
                      id="memberFirst"
                      name="memberFirst"
                      value={member.memberFirst}
                      onChange={this.setMemberFirst}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="5" md="5">
                  <FormGroup for="memberLast">
                    <Label for="memberLast">
                      Member's Last Name*
                    </Label>
                    <Field
                      type="text"
                      id="memberLast"
                      name="memberLast"
                      value={member.memberLast}
                      onChange={this.setMemberLast}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="2" md="2">
                  <FormGroup for="memberInitial">
                    <Label for="memberInitial">
                      Middle Initial
                    </Label>
                    <Field
                      type="text"
                      id="memberInitial"
                      name="memberInitial"
                      value={member.memberInitial}
                      onChange={this.setMemberInitial}
                      maxLength={1}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col xs="12" sm="3" md="3">
                  <Label for="DOB">
                    Date of Birth*
                  </Label>
                  <DateField
                    id="DOB"
                    name="DOB"
                    value={member.memDOB}
                    onChange={this.setMemberDOB}
                    placeholder='MM/DD/YYYY'
                    max={moment().format('MM/DD/YYYY')}
                  />
                </Col>
                <Col xs="12" sm="3" md="3">
                  <FormGroup for="subscriberId">
                    <Label id="hbIdLabel" for="hbId">
                      Subscriber ID* <span id="hbId-help" className="inline-help" />
                    </Label>
                    <UncontrolledTooltip target="hbIdLabel" placement="right"
                      innerClassName="text-left">
                      {`Please enter the subscriber id as it is on the member id card`}
                    </UncontrolledTooltip>
                    <Field
                      type="text"
                      id="subscriberId"
                      name="subscriberId"
                      value={member.subscriberId}
                      onChange={this.setMemberSubscriberId}
                      maxLength={12}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup for="memberStreetSuite">
                    <Label for="memberStreetSuite">
                      Member Street Address/Suite Number*
                    </Label>
                    <Field
                      type="text"
                      id="memberStreetSuite"
                      name="memberStreetSuite"
                      value={member.memStreetSuite}
                      onChange={this.setMemberStreetSuite}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="7" md="7">
                  <FormGroup for="memCity">
                    <Label for="memCity">
                      City*
                    </Label>
                    <Field
                      type="text"
                      id="memCity"
                      name="memCity"
                      value={member.memCity}
                      onChange={this.setMemberCity}
                      maxLength={50}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="2" md="2">
                  <FormGroup for="memState">
                    <Label for="memState">
                      State*
                    </Label>
                    <SelectField
                      name="memState"
                      className="member-state"
                      value={member.memState}
                      onChange={this.setMemState}
                      placeholder="Select"
                      options={states.map(state => (
                        {
                          value: state.abbreviation, label: state.name
                        }
                      ))}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12" sm="3" md="3">
                  <FormGroup for="memZip">
                    <Label for="memZip">
                      Zip*
                    </Label>
                    <Field
                      id="memZip"
                      name="memZip"
                      value={member.memZip}
                      onChange={this.setMemZip}
                      placeholder='12345-1234'
                      maxLength={10}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12" sm="8" md="7">
                  <FormGroup for="memPhone">
                    <Label for="memPhone">
                      Phone* <span className="inline-help">Member, Parent/Guardian, Authorized Representative</span>
                    </Label>
                    <Field
                      id="memPhone"
                      name="memPhone"
                      value={member.memPhone}
                      onChange={this.setMemPhone}
                      placeholder="0123456789"
                      maxLength={10}
                    />
                  </FormGroup>
                </Col>
                <Col className="pt-28 pl-25">
                  <RadioGroup inline value={memPhoneType} name="memberPhoneRadio">
                    <Radio className="radio-spacing" label="Home" value="Home" onChange={this.setMemPhoneType} />
                    <Radio className="radio-spacing" label="Cell" value="Cell" onChange={this.setMemPhoneType} />
                  </RadioGroup>
                </Col>
              </Row>
              <div className='spacer'>

                <h6><b>Parent/Guardian</b> (required for minors)</h6>
                <Row>
                  <Col xs="12" sm="5" md="5">
                    <FormGroup for="pgFirstName">
                      <Label for="pgFirstName">
                        First Name
                      </Label>
                      <Field
                        type="text"
                        id="pgFirstName"
                        name="pgFirstName"
                        value={pg.pgFirstName}
                        onChange={this.setPGFirstName}
                        maxLength={50}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="5" md="5">
                    <FormGroup for="pgLastName">
                      <Label for="pgLastName">
                        Last Name
                      </Label>
                      <Field
                        id="pgLastName"
                        name="pgLastName"
                        value={pg.pgLastName}
                        onChange={this.setPGLastName}
                        maxLength={50}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="2" md="2">
                    <FormGroup for="pgMiddleInitial">
                      <Label for="pgMiddleInitial">
                        Middle Initial
                      </Label>
                      <Field
                        id="pgMiddleInitial"
                        name="pgMiddleInitial"
                        value={pg.pgMiddleInitial}
                        onChange={this.setPGMiddleInital}
                        maxLength={1}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col xs="12" sm="5" md="5">
                    <FormGroup for="pgRelation">
                      <Label for="pgRelation">
                        Relationship to Member
                      </Label>
                      <Field
                        id="pgRelation"
                        name="pgRelation"
                        value={pg.pgRelation}
                        onChange={this.setPGRelation}
                        maxLength={50}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              <div className='spacer'>
                <h6><b>Authorized Representative</b> (if applicable)</h6>
                <Row>
                  <Col xs="12" sm="5" md="5">
                    <FormGroup for="authRepFirstName">
                      <Label for="authRepFirstName">
                        First Name
                      </Label>
                      <Field
                        type="text"
                        id="authRepFirstName"
                        name="authRepFirstName"
                        value={authRep.authRepFirstName}
                        onChange={this.setAuthRepFirstName}
                        maxLength={50}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="5" md="5">
                    <FormGroup for="authRepLastName">
                      <Label for="authRepLastName">
                        Last Name
                      </Label>
                      <Field
                        id="authRepLastName"
                        name="authRepLastName"
                        value={authRep.authRepLastName}
                        onChange={this.setAuthRepLastName}
                        maxLength={50}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="2" md="2">
                    <FormGroup for="authRepMiddleInitial">
                      <Label for="authRepMiddleInitial">
                        Middle Initial
                      </Label>
                      <Field
                        id="authRepMiddleInitial"
                        name="authRepMiddleInitial"
                        value={authRep.authRepMiddleInitial}
                        onChange={this.setAuthRepMiddleInital}
                        maxLength={1}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" sm="5" md="5">
                    <FormGroup for="authRepRelation">
                      <Label for="authRepRelation">
                        Relationship to Member
                      </Label>
                      <Field
                        id="authRepRelation"
                        name="authRepRelation"
                        value={authRep.authRelation}
                        onChange={this.setAuthRepRelation}
                        maxLength={50}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
                Next
              </Button>
            </Form>
          </div>
        </CardBody>
      </Card >
    );
  }
}

MemberInfo.propTypes = {
  history: PropTypes.object
};